import React from "react";
//import PropTypes from 'prop-types';

import Networking from "joynt/components/SessionPage/Networking";

export default function Sessions(props) {
    return <Networking {...props} />;
}
